import script from "./SsoLinkButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SsoLinkButton.vue?vue&type=script&setup=true&lang=js"

import "./SsoLinkButton.vue?vue&type=style&index=0&id=b372c3b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b372c3b6"]])

export default __exports__